import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'
import { UserService } from 'src/app/services/user/user.service'
import { Header } from './header'

/**
 * deprecated
 */

@Component({
  selector: 'profile-edit-header',
  template: `
    <app-header [title]="this.title">
      <button
        button
        class="button profile-edit"
        type="submit"
        click
        [elementName]="'submit'"
        (throttledClick)="onClickSubmit()"
      >
        완료
      </button>
    </app-header>
  `,
  styleUrls: ['./header.component.scss'],
})
export class ProfileEditHeaderComponent extends Header {
  @Input() title = ''
  @Output() submitClick = new EventEmitter<void>()

  constructor(
    public userService: UserService,
    protected generalService: GeneralService,
    protected logService: LogService
  ) {
    super(generalService, logService)
  }
  onClickSubmit(): void {
    this.submitClick.emit()
  }
}
